import React from "react";
import MethodGet, { MethodDelete, MethodPost } from "../../config/Service";
import headerConfig from "../../config/imageHeaders";
import { useReducer } from "react";
import EnterProductsReducer from "./EnterProductsReducer";
import EnterProductsContext from "./EnterProductsContext";
import Swal from "sweetalert2";
import { CREATE_ENTER_PRODUCTS, GET_ALL_ENTER_PRODUCTS } from "../../types";
import fileDownload from "js-file-download";
import clienteAxios from "../../config/Axios";
const EnterProductsState = ({ children }) => {
  const initialState = {
    enter_products: [],
    products_b: [],
    ErrorsApi: [],
    success: false,
  };
  const [state, dispatch] = useReducer(EnterProductsReducer, initialState);
  //Funcion para obtener todos los productos auth
  const GetEnterProducts = () => {
    let url = `/entradas`;
    MethodGet(url)
      .then((res) => {
        dispatch({
          type: GET_ALL_ENTER_PRODUCTS,
          payload: res.data.entradas,
        });
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const CreateEnterProducts = (data) => {
    let url = "/enter-products";
    MethodPost(url, data)
      .then((res) => {
        dispatch({
          type: CREATE_ENTER_PRODUCTS,
          payload: res.data,
        });
        Swal.fire({
          title: "Registrado",
          text: "La entrada de productos se ha creado exitosamente!",
          icon: "success",
          timer: 1500,
          showConfirmButton: false,
        });
      })
      .catch((error) => {
        console.log(error);
        Swal.fire({
          title: "error",
          showConfirmButton: false,
          icon: "error",
          text: error.response.data.message,
          timer: 1500,
        });
      });
  };

  const DownloadPdfEnterProducts = (id) => {
    Swal.fire({
      title: "¿Descargar PDF?",
      text: "Se descargará el reporte de entradas en PDF",
      icon: "question",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Si, descargar",
      cancelButtonText: "No, cancelar",
    }).then((result) => {
      if (result.value) {
        let url = `/entries/${id}/report`;
        clienteAxios
          .get(url, { responseType: "blob" })
          .then((res) => {
            Swal.fire({
              title: "Generando",
              html: "El PDF se esta generando!",
              timer: 2000,
              timerProgressBar: true,
              showConfirmButton: false,
              showLoading: true,
            }).then((result) => {
              fileDownload(res.data, `Reporte_entradas_${id}.pdf`);
              Swal.fire({
                title: "Descargado",
                text: "El PDF de las entradas se ha descargado correctamente",
                icon: "success",
                timer: 1500,
                showConfirmButton: false,
              });
            });
          })
          .catch((error) => {
            Swal.fire({
              title: "Error",
              icon: "error",
              text: error.response.data.message,
            });
          });
      }
    });
  };
  return (
    <EnterProductsContext.Provider
      value={{
        enter_products: state.enter_products,
        ErrorsApi: state.ErrorsApi,
        success: state.success,
        GetEnterProducts,
        CreateEnterProducts,
        DownloadPdfEnterProducts,
      }}
    >
      {children}
    </EnterProductsContext.Provider>
  );
};

export default EnterProductsState;
